import { extend } from 'vue-breakpoint-component';
// Full docs: https://github.com/adi518/vue-breakpoint-component

const config = {
    breakpoints: {
        small: false,
        medium: false,
        large: '(min-width: 980px)',
        xlarge: false,
    },
    debounceTime: 100,
    experimental: false,
};

const { VShowAt, VHideAt, VBreakpoint } = extend(config);

export default VBreakpoint;
export { VShowAt, VHideAt, VBreakpoint };
